import React from 'react';
import PropTypes from 'prop-types';

class LiveInternet extends React.Component {
  shouldComponentUpdate () {
    return false;
  }

  render () {
    if (process.env.BROWSER) {
      const urlParams = [];

      if (this.props.cityId === 55) {
        urlParams.push('OMSK');
      } else if (this.props.cityId === 16) {
        urlParams.push('KAZAN');
      }

      if (this.props.isRealtor) {
        urlParams.push('R');
      } else {
        urlParams.push('U');
      }

      const screenString = typeof (screen) === 'undefined'
        ? ''
        : `;s${screen.width}*${screen.height}*${(screen.colorDepth ? screen.colorDepth : screen.pixelDepth)}`;

      const src = `https://counter.yadro.ru/hit;MLSN/${urlParams.join('/')}
      ?r${escape(document.referrer)}
      ${screenString}
      ;u${escape(document.URL)};h${escape(document.title.substring(0, 80))}
      ;${Math.random()}
      }`;

      new Image().src = src;
    }

    return (
      <a href={`https://www.liveinternet.ru/click;MLSN${this.props.cityId === 55 ? '/OMSK' : ''}`} target='_blank' rel='nofollow'>
        <img
          className='live-internet-counter'
          src={`https://counter.yadro.ru/logo;MLSN${this.props.cityId === 55 ? '/OMSK' : ''}?18.2`}
          title='LiveInternet: показано число посетителей за сегодня' width='88' height='31'
        />
      </a>
    );
  }
}

LiveInternet.propTypes = {
  cityId: PropTypes.number,
  isRealtor: PropTypes.bool
};

export default LiveInternet;



// WEBPACK FOOTER //
// ./src/ui/Metric/LiveInternet.js